// extracted by mini-css-extract-plugin
export default {"loader":"content_loader__VyC7u","count":"content_count__Q67Yp"};